import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getTestCaseResultsByUserTag = async (userTags = [], testSuiteResultId) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No User details found in localStorage");
  if (!userTags || userTags.length === 0) throw new Error("At least one tag must be provided");

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTestCaseResultsByUserTag&testSuiteResultId=${testSuiteResultId}`,
    { tags: userTags },
  );

  return response.data;
};

const useGetTestCaseResultsByUserTag = (userTags, testSuiteResultId, options = {}) => {
  return useQuery({
    queryKey: ["testCaseResultsByUserTag", userTags, testSuiteResultId],
    queryFn: () => getTestCaseResultsByUserTag(userTags, testSuiteResultId),
    enabled: options?.enabled !== undefined ? options.enabled : true,
    ...options,
  });
};

export default useGetTestCaseResultsByUserTag;
